import { createContext, useContext } from 'react';
import { useLocalStorageState } from '@Common/hooks/useLocalStorage';
import { KEYS } from 'src/researcher/constants/common.constants';

const ConfirmBeforeDeleteContext = createContext<any>(null);

export function ConfirmBeforeDeleteProvider(props: React.PropsWithChildren<any>) {
  const sd = useLocalStorageState(KEYS.LOCALSTORAGE_NEVER_ASK_DELETE_PROJECT, true);
  return (
    <ConfirmBeforeDeleteContext.Provider value={sd}>
      {props.children}
    </ConfirmBeforeDeleteContext.Provider>
  );
}

export function useConfirmBeforeDelete() {
  return useContext(ConfirmBeforeDeleteContext);
}
